export default __webpack_public_path__ + "static/building-8ab1ad23e44f186516a7a3a8a107eab4.png";